import { Rating, TextareaAutosize, Typography } from "@mui/material";
import styled from "styled-components";
import StarIcon from "@mui/icons-material/Star";
import { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";

interface Props {
  evaluationData: any;
  ratingData: any;
  setRatingData: any;
  setStateChanged: any;
  actionTypes?: any[];
}

const SubHeader = styled.th`
  padding: 10px;
  font-size: 14px;
  font-weight: normal;
  flex-grow: 1;
  text-align: left;
  vertical-align: top;

  &:first-child {
    border-left: 1px solid rgb(10 13 31);
  }
`;
const Header = styled.th`
  padding: 10px;
  font-size: 16px;
  font-weight: bold;
  min-width: 70px;
`;
const RowHeader = styled.th`
  font-size: 16px;
  font-weight: normal;
  vertical-align: top;
  padding: 10px;
`;
const RatingStyle = styled.td`
  padding: 10px;
  vertical-align: top;
`;

export const EvaluateTable = (props: Props) => {
  const {
    evaluationData,
    ratingData,
    setRatingData,
    setStateChanged,
    actionTypes,
  } = props;

  // const [ratingData, setRatingData] = useState(evaluationData.ratings);
  const [ratings, setRatings] = useState(evaluationData.ratings);
  const [hoursDraft, setHoursDraft] = useState<Record<string, string>>({});

  const ratingDescriptions = [
    "Not Rated",
    "Poor",
    "Fair",
    "Good",
    "Very Good",
    "Excellent",
  ];

  const getRatings = () => {
    axios
      .get("/rating")
      .then((res) => {
        if (res.data) setRatings(res.data?.ratings);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };
  // useEffect(() => {
  //   getRatings();
  // }, []);

  const updateRating = (competency_code: any, key: string, newRating: any) => {
    setStateChanged(true);
    setRatingData((prevItems: any) =>
      prevItems?.map((item: any) =>
        item.competency_code === competency_code
          ? {
            ...item,
            [key]:
              newRating ??
              (key === "comments"
                ? ""
                : key === "improvement_action_types"
                  ? []
                  : 0),
          }
          : item
      )
    );
  };

  const selfOptions = [
    {
      label: "Attended most of the lectures",
      value: 1,
    },
    {
      label: "Attended most of the lab sessions",
      value: 2,
    },
    { label: "Asked questions in class", value: 3 },
    {
      label: "Visited the instructor during office hours",
      value: 4,
    },
    {
      label: "Studied additional resources or material",
      value: 5,
    },
    {
      label: "Submitted practice assignments",
      value: 6,
    },
    { label: "None of the above", value: 7 },
  ];

  return (
    <div
      style={{
        borderRadius: "3px",
        // background: "rgba(236, 197, 198, 0.1)",
        // width: 100%,
        maxHeight: "85vh",
        minHeight: "85vh",
        overflowY: "auto",
        position: "relative",
      }}
      className="evaluate visible-scrollbar"
    >
      <table style={{ width: "100%" }}>
        <thead
          style={{
            position: window.innerWidth > 1300 ? "sticky" : "relative",
            // position: "sticky",
            top: 0,
            background: "#090a14",
            zIndex: 1000,
            // zIndex: 1000,
          }}
        >
          <tr className="borderBottom">
            <Header style={{ minWidth: 80 }} align="center" rowSpan={2}>
              Code
            </Header>
            <Header style={{ minWidth: 150 }} rowSpan={2}>
              Competency
            </Header>
            <Header style={{ minWidth: 80 }} align="center" rowSpan={2}>
              Credits
            </Header>
            {/* <Header
              style={{
                top: 0,
                borderLeft: "1px solid #2b2b2b",
              }}
              colSpan={7}
              align="center"
            >
              Questions
            </Header> */}
          </tr>
          <tr className="borderBottom">
            <SubHeader>
              Overall, how would you rate the competency content?
            </SubHeader>
            <SubHeader>
              Rate the instructor's ability to explain concepts and facilitate
              learning?
            </SubHeader>
            <SubHeader>
              Were the assessments (exams, assignments) fair and representative
              of the competency content? Please rate.
            </SubHeader>
            <SubHeader style={{ borderRight: "3px solid #ffc10779 " }}>
              Overall, how would you rate the instructor?
            </SubHeader>
            <SubHeader style={{ boxShadow: 'inset 10px 0 30px -5px #000000a8' }}>
              How do you rate your own effort in this competency?
            </SubHeader>
            <SubHeader>
              What actions did you take to improve your mastery?
            </SubHeader>
            <SubHeader>
              Approximately how much time did you spend on self-study for this competency throughout the semester?
            </SubHeader>
            <SubHeader>
              Please share any other comments or suggestions about the
              competency or instructor.
            </SubHeader>
          </tr>
        </thead>

        {ratingData?.map((d: any) => (
          <tr key={d.competency_code}>
            <RowHeader
              style={{
                color:
                  d.assessment_rating &&
                    d.assessment_rating &&
                    d.instructor_rating &&
                    d.overall_rating &&
                    d.teaching_ability_rating &&
                    d.self_effort_rating &&
                    d.improvement_action_types &&
                    d.self_study_hours
                    ? "white"
                    : "#ffff8f",
              }}
            >
              {d.competency_code}
            </RowHeader>
            <RowHeader
              style={{
                textAlign: "left",
                fontSize: 14,
                color:
                  d.assessment_rating &&
                    d.instructor_rating &&
                    d.overall_rating &&
                    d.teaching_ability_rating &&
                    d.self_effort_rating &&
                    d.improvement_action_types &&
                    d.self_study_hours
                    ? "white"
                    : "#ffff8f",
              }}
            >
              {d.competency_title}
            </RowHeader>
            <RowHeader
              style={{
                textAlign: "center",
                fontSize: 14,
                color:
                  d.assessment_rating &&
                    d.instructor_rating &&
                    d.overall_rating &&
                    d.teaching_ability_rating &&
                    d.self_effort_rating &&
                    d.improvement_action_types
                    ? "white"
                    : "#ffff8f",
              }}
            >
              {d.credits}
            </RowHeader>
            <RatingStyle style={{ borderLeft: "1px solid rgb(10 13 31)" }}>
              <Typography sx={{ fontSize: 14 }} component="legend">
                {ratingDescriptions[d.overall_rating] || "Not Rated"}
              </Typography>
              <Rating
                // disabled={d.card_status !== "Completed"}
                name="overall_rating"
                value={d.overall_rating}
                onChange={(event, newValue) => {
                  updateRating(d.competency_code, "overall_rating", newValue);
                }}
                emptyIcon={
                  <StarIcon
                    style={{ opacity: 1, color: "gray" }}
                    fontSize="inherit"
                  />
                }
              />
            </RatingStyle>
            <RatingStyle>
              <Typography sx={{ fontSize: 14 }} component="legend">
                {ratingDescriptions[d.teaching_ability_rating] || "Not Rated"}
              </Typography>
              <Rating
                // disabled={d.card_status !== "Completed"}
                name="learning_rating"
                value={d.teaching_ability_rating}
                onChange={(event, newValue) => {
                  updateRating(
                    d.competency_code,
                    "teaching_ability_rating",
                    newValue
                  );
                }}
                emptyIcon={
                  <StarIcon
                    style={{ opacity: 1, color: "gray" }}
                    fontSize="inherit"
                  />
                }
              />
            </RatingStyle>
            <RatingStyle>
              <Typography sx={{ fontSize: 14 }} component="legend">
                {ratingDescriptions[d.assessment_rating] || "Not Rated"}
              </Typography>
              <Rating
                // disabled={d.card_status !== "Completed"}
                name="learning_rating"
                value={d.assessment_rating}
                onChange={(event, newValue) => {
                  updateRating(
                    d.competency_code,
                    "assessment_rating",
                    newValue
                  );
                }}
                emptyIcon={
                  <StarIcon
                    style={{ opacity: 1, color: "gray" }}
                    fontSize="inherit"
                  />
                }
              />
            </RatingStyle>
            <RatingStyle style={{ borderRight: "3px solid #ffc10779 " }}>
              <Typography sx={{ fontSize: 14 }} component="legend">
                {ratingDescriptions[d.instructor_rating] || "Not Rated"}
              </Typography>
              <Rating
                // disabled={d.card_status !== "Completed"}
                name="instructor_rating"
                value={d.instructor_rating}
                onChange={(event, newValue) => {
                  updateRating(
                    d.competency_code,
                    "instructor_rating",
                    newValue
                  );
                }}
                emptyIcon={
                  <StarIcon
                    style={{ opacity: 1, color: "gray" }}
                    fontSize="inherit"
                  />
                }
              />
            </RatingStyle>
            <RatingStyle style={{ boxShadow: 'inset 10px 0 30px -5px #000000a8' }}>
              <Typography sx={{ fontSize: 14 }} component="legend">
                {ratingDescriptions[d.self_effort_rating] || "Not Rated"}
              </Typography>
              <Rating
                // disabled={d.card_status !== "Completed"}
                name="self_effort_rating"
                value={d.self_effort_rating}
                onChange={(event, newValue) => {
                  updateRating(
                    d.competency_code,
                    "self_effort_rating",
                    newValue
                  );
                }}
                emptyIcon={
                  <StarIcon
                    style={{ opacity: 1, color: "gray" }}
                    fontSize="inherit"
                  />
                }
              />
            </RatingStyle>
            <RatingStyle style={{ width: "200px" }}>
              <Select
                isMulti
                closeMenuOnSelect={false}
                isClearable={false}
                onChange={(newValue) => {
                  const selectedValues = newValue
                    ? newValue.map((option) => option.value)
                    : [];

                  let filteredValues = [];

                  if (selectedValues.includes(7) && selectedValues.length > 1) {
                    // If "None of the above" is selected AND there are other selections,
                    // remove "None of the above" and keep the others
                    filteredValues = selectedValues.filter(
                      (value) => value !== 7
                    );
                  } else if (selectedValues.includes(7)) {
                    // If ONLY "None of the above" is selected, keep only that
                    filteredValues = [7];
                  } else {
                    // Otherwise, filter out "None of the above"
                    filteredValues = selectedValues.filter(
                      (value) => value !== 7
                    );
                  }
                  updateRating(
                    d.competency_code,
                    "improvement_action_types",
                    filteredValues
                  );
                }}
                placeholder="Select"
                // defaultValue={[selfOptions[2], selfOptions[3]]}
                // value={
                //   d.improvement_actions
                //     ? {
                //         label: d.improvement_actions,
                //         value: d.improvement_actions,
                //       }
                //     : null
                // }
                value={
                  d.improvement_action_types
                    ? d.improvement_action_types
                      ?.map((actionId: any) => {
                        const option = Array.isArray(actionTypes)
                          ? actionTypes.find((opt) => opt.value === actionId)
                          : null;
                        return option
                          ? { label: option.label, value: option.value }
                          : null;
                      })
                      .filter((option: any) => option !== null)
                    : []
                }
                menuPlacement="auto"
                menuPortalTarget={document.body}
                options={actionTypes?.map((option) => ({
                  ...option,
                  isDisabled:
                    d.improvement_action_types &&
                    d.improvement_action_types.length > 0 &&
                    !d.improvement_action_types.includes(7) &&
                    option.value === 7,
                }))}
                styles={{
                  control: (base) => ({
                    ...base,
                    background: "#00000012",
                    borderRadius: 5,
                    color: "white",
                    fontSize: 14,
                    position: "relative",
                    right: 0,
                    maxWidth: "200px",
                  }),
                  menu: (base) => ({
                    ...base,
                    width: "500px",
                    zIndex: 99999,
                    position: "absolute",
                    right: 0,
                  }),
                  menuPortal: (baseStyles, state) => ({
                    ...baseStyles,
                    zIndex: 99999,
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: "white",
                  }),
                  multiValue: (styles, { data }) => {
                    return {
                      ...styles,
                      background:
                        "linear-gradient(90deg, rgb(176, 52, 52) 0%, rgb(24, 75, 104) 118.29%)",
                    };
                  },
                  multiValueLabel: (styles, { data }) => ({
                    ...styles,
                    color: data.color,
                  }),
                }}
              />
            </RatingStyle>
            <RatingStyle>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  width: "75%",
                  margin: "0 auto",
                }}
              >
                <input
                  type="number"
                  min={0}
                  max={800}
                  step="any"
                  aria-label="approximate hours"
                  placeholder="≈ hours"
                  value={
                    hoursDraft[d.competency_code] !== undefined
                      ? hoursDraft[d.competency_code]
                      : d.self_study_hours
                        ? d.self_study_hours
                        : ""
                  }
                  onKeyDown={(event) => {
                    if (event.key === "-" || event.key === "e" || event.key === "E" || event.key === "+") {
                      event.preventDefault();
                    }
                  }}
                  onChange={(event) => {
                    const raw = event.target.value;
                    if (raw !== "" && !/^\d*\.?\d*$/.test(raw)) {
                      return;
                    }
                    setHoursDraft((prev) => ({
                      ...prev,
                      [d.competency_code]: raw,
                    }));
                    if (raw === "" || raw === ".") {
                      updateRating(d.competency_code, "self_study_hours", 0);
                      return;
                    }
                    const parsed = parseFloat(raw);
                    const clamped = Number.isNaN(parsed)
                      ? 0
                      : Math.min(800, Math.max(0, parsed));
                    if (!Number.isNaN(parsed) && clamped !== parsed) {
                      setHoursDraft((prev) => ({
                        ...prev,
                        [d.competency_code]: String(clamped),
                      }));
                    }
                    updateRating(d.competency_code, "self_study_hours", clamped);
                  }}
                  onBlur={() => {
                    setHoursDraft((prev) => {
                      const next = { ...prev };
                      delete next[d.competency_code];
                      return next;
                    });
                  }}
                  style={{
                    flex: 1,
                    minWidth: 0,
                    minHeight: 38,
                    height: 38,
                    boxSizing: "border-box",
                    background: "#00000012",
                    border: "1px solid white",
                    borderRadius: 5,
                    color: "white",
                    fontSize: 14,
                    padding: "2px 8px",
                    lineHeight: "34px",
                    outline: "none",
                  }}
                />
                <span style={{ color: "white", fontSize: 14, flexShrink: 0 }}>
                  hrs
                </span>
              </div>
            </RatingStyle>
            <td style={{ verticalAlign: "top" }}>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  // height: "100%",
                }}
              >
                <TextareaAutosize
                  // disabled={d.card_status !== "Completed"}
                  style={{
                    width: "100%",
                    // height: "fit-content",
                    // height: "100%",
                    background: "#ffffff12",
                    borderRadius: 5,
                    color: "white",
                    fontSize: 14,
                    overflow: "hidden",
                    // resize: "none",
                  }}
                  // maxRows={4}
                  minRows={d.improvement_action_types?.length + 3 || 3}
                  aria-label="maximum height"
                  placeholder="Write your comment here!"
                  value={d.comments}
                  onChange={(event: any) => {
                    updateRating(
                      d.competency_code,
                      "comments",
                      event.target.value
                    );
                  }}
                />
              </div>
            </td>
          </tr>
        ))}
      </table>
    </div>
  );
};
